/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * CMS APIs
 * OpenAPI specification derived from CMSApis.kt
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BookWiseChapterResponse,
  BooksResponse,
  CODResponse,
  DocumentObject,
  DocumentsResponse,
  FlashCardDetailsResponse,
  FormulaSheetList,
  FormulaSheetResponse,
  GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  GetExamtocV2GetSubjectsForExamExamIdParams,
  GetFlashcardGetFlashcardByFlashcardIdsParams,
  GetRecommendationGetRecommendationsParams,
  GetStoryGetStoriesForExamNodeIdsParams,
  LanguageObj,
  ListOfStoryResponse,
  MemoryFlashcardResponse,
  PracticeListResponse,
  QuestionIdsResponse,
  ReviseVideoResponse,
  SearchFlashcardResponse,
  StoryResponse,
  SubjectResponse,
  SubjectWiseBooksResponse,
  TopicDetailsSummaryResponse,
  TopicWiseVideosResponse,
  VideoObject,
  VideoPlaylistResponse,
  VideosResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get formula sheet details by ID
 */
export const getFlashcardGetFormulaSheetDetailsByIdFlashcardId = (
  flashcardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<FormulaSheetResponse>(
    {
      url: `/flashcard/getFormulaSheetDetailsById/${flashcardId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryKey = (
  flashcardId?: number,
) => {
  return [`/flashcard/getFormulaSheetDetailsById/${flashcardId}`] as const;
};

export const getGetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
    >,
    TError = unknown,
  >(
    flashcardId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryKey(flashcardId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
      >
    > = ({ signal }) =>
      getFlashcardGetFormulaSheetDetailsByIdFlashcardId(
        flashcardId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!flashcardId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
    >
  >;
export type GetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryError =
  unknown;

export function useGetFlashcardGetFormulaSheetDetailsByIdFlashcardId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
  >,
  TError = unknown,
>(
  flashcardId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFormulaSheetDetailsByIdFlashcardId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
  >,
  TError = unknown,
>(
  flashcardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFormulaSheetDetailsByIdFlashcardId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
  >,
  TError = unknown,
>(
  flashcardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get formula sheet details by ID
 */

export function useGetFlashcardGetFormulaSheetDetailsByIdFlashcardId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
  >,
  TError = unknown,
>(
  flashcardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetDetailsByIdFlashcardId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetFlashcardGetFormulaSheetDetailsByIdFlashcardIdQueryOptions(
      flashcardId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get formula sheets by chapter ID
 */
export const getFlashcardGetFormulaSheetByChapterIdChapterId = (
  chapterId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<FormulaSheetList>(
    {
      url: `/flashcard/getFormulaSheetByChapterId/${chapterId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetFlashcardGetFormulaSheetByChapterIdChapterIdQueryKey = (
  chapterId?: number,
) => {
  return [`/flashcard/getFormulaSheetByChapterId/${chapterId}`] as const;
};

export const getGetFlashcardGetFormulaSheetByChapterIdChapterIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
  >,
  TError = unknown,
>(
  chapterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFlashcardGetFormulaSheetByChapterIdChapterIdQueryKey(chapterId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>>
  > = ({ signal }) =>
    getFlashcardGetFormulaSheetByChapterIdChapterId(
      chapterId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!chapterId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFlashcardGetFormulaSheetByChapterIdChapterIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>>
  >;
export type GetFlashcardGetFormulaSheetByChapterIdChapterIdQueryError = unknown;

export function useGetFlashcardGetFormulaSheetByChapterIdChapterId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
  >,
  TError = unknown,
>(
  chapterId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFormulaSheetByChapterIdChapterId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
  >,
  TError = unknown,
>(
  chapterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFormulaSheetByChapterIdChapterId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
  >,
  TError = unknown,
>(
  chapterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get formula sheets by chapter ID
 */

export function useGetFlashcardGetFormulaSheetByChapterIdChapterId<
  TData = Awaited<
    ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
  >,
  TError = unknown,
>(
  chapterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getFlashcardGetFormulaSheetByChapterIdChapterId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetFlashcardGetFormulaSheetByChapterIdChapterIdQueryOptions(
      chapterId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get books and asset count
 */
export const getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId = (
  examId: number,
  subjectId: number,
  subtenantId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BooksResponse>(
    {
      url: `/examtoc/getBooksAndAssetCount/${examId}/${subjectId}/${subtenantId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryKey =
  (examId?: number, subjectId?: number, subtenantId?: number) => {
    return [
      `/examtoc/getBooksAndAssetCount/${examId}/${subjectId}/${subtenantId}`,
    ] as const;
  };

export const getGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
      >
    >,
    TError = unknown,
  >(
    examId: number,
    subjectId: number,
    subtenantId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryKey(
        examId,
        subjectId,
        subtenantId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
        >
      >
    > = ({ signal }) =>
      getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId(
        examId,
        subjectId,
        subtenantId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(examId && subjectId && subtenantId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
      >
    >
  >;
export type GetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryError =
  unknown;

export function useGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId<
  TData = Awaited<
    ReturnType<typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  subtenantId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId<
  TData = Awaited<
    ReturnType<typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId<
  TData = Awaited<
    ReturnType<typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get books and asset count
 */

export function useGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId<
  TData = Awaited<
    ReturnType<typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocGetBooksAndAssetCountExamIdSubjectIdSubtenantIdQueryOptions(
      examId,
      subjectId,
      subtenantId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get videos from playlist
 */
export const getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId = (
  examId: number,
  subtenantId: number,
  playlistTypeId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideoPlaylistResponse>(
    {
      url: `/video_playlist/get/videos/${examId}/${subtenantId}/${playlistTypeId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryKey =
  (examId?: number, subtenantId?: number, playlistTypeId?: number) => {
    return [
      `/video_playlist/get/videos/${examId}/${subtenantId}/${playlistTypeId}`,
    ] as const;
  };

export const getGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
      >
    >,
    TError = unknown,
  >(
    examId: number,
    subtenantId: number,
    playlistTypeId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryKey(
        examId,
        subtenantId,
        playlistTypeId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
        >
      >
    > = ({ signal }) =>
      getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId(
        examId,
        subtenantId,
        playlistTypeId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(examId && subtenantId && playlistTypeId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
      >
    >
  >;
export type GetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryError =
  unknown;

export function useGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId<
  TData = Awaited<
    ReturnType<typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId>
  >,
  TError = unknown,
>(
  examId: number,
  subtenantId: number,
  playlistTypeId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId<
  TData = Awaited<
    ReturnType<typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId>
  >,
  TError = unknown,
>(
  examId: number,
  subtenantId: number,
  playlistTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId<
  TData = Awaited<
    ReturnType<typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId>
  >,
  TError = unknown,
>(
  examId: number,
  subtenantId: number,
  playlistTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get videos from playlist
 */

export function useGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId<
  TData = Awaited<
    ReturnType<typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId>
  >,
  TError = unknown,
>(
  examId: number,
  subtenantId: number,
  playlistTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetVideoPlaylistGetVideosExamIdSubtenantIdPlaylistTypeIdQueryOptions(
      examId,
      subtenantId,
      playlistTypeId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get subjects for exam
 */
export const getExamtocV2GetSubjectsForExamExamId = (
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SubjectResponse>(
    {
      url: `/examtoc/v2/getSubjectsForExam/${examId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetExamtocV2GetSubjectsForExamExamIdQueryKey = (
  examId?: number,
  params?: GetExamtocV2GetSubjectsForExamExamIdParams,
) => {
  return [
    `/examtoc/v2/getSubjectsForExam/${examId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetExamtocV2GetSubjectsForExamExamIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
  TError = unknown,
>(
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetExamtocV2GetSubjectsForExamExamIdQueryKey(examId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>
  > = ({ signal }) =>
    getExamtocV2GetSubjectsForExamExamId(
      examId,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!examId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExamtocV2GetSubjectsForExamExamIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>
>;
export type GetExamtocV2GetSubjectsForExamExamIdQueryError = unknown;

export function useGetExamtocV2GetSubjectsForExamExamId<
  TData = Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
  TError = unknown,
>(
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
          TError,
          Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocV2GetSubjectsForExamExamId<
  TData = Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
  TError = unknown,
>(
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
          TError,
          Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocV2GetSubjectsForExamExamId<
  TData = Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
  TError = unknown,
>(
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get subjects for exam
 */

export function useGetExamtocV2GetSubjectsForExamExamId<
  TData = Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
  TError = unknown,
>(
  examId: number,
  params: GetExamtocV2GetSubjectsForExamExamIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getExamtocV2GetSubjectsForExamExamId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetExamtocV2GetSubjectsForExamExamIdQueryOptions(
    examId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get recommended videos
 */
export const getRecommendationGetRecommendations = (
  params: GetRecommendationGetRecommendationsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideosResponse>(
    {
      url: `/recommendation/get_recommendations`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetRecommendationGetRecommendationsQueryKey = (
  params?: GetRecommendationGetRecommendationsParams,
) => {
  return [
    `/recommendation/get_recommendations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRecommendationGetRecommendationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
  TError = unknown,
>(
  params: GetRecommendationGetRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRecommendationGetRecommendationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecommendationGetRecommendations>>
  > = ({ signal }) =>
    getRecommendationGetRecommendations(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetRecommendationGetRecommendationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecommendationGetRecommendations>>
>;
export type GetRecommendationGetRecommendationsQueryError = unknown;

export function useGetRecommendationGetRecommendations<
  TData = Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
  TError = unknown,
>(
  params: GetRecommendationGetRecommendationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
          TError,
          Awaited<ReturnType<typeof getRecommendationGetRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRecommendationGetRecommendations<
  TData = Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
  TError = unknown,
>(
  params: GetRecommendationGetRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
          TError,
          Awaited<ReturnType<typeof getRecommendationGetRecommendations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRecommendationGetRecommendations<
  TData = Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
  TError = unknown,
>(
  params: GetRecommendationGetRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get recommended videos
 */

export function useGetRecommendationGetRecommendations<
  TData = Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
  TError = unknown,
>(
  params: GetRecommendationGetRecommendationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getRecommendationGetRecommendations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRecommendationGetRecommendationsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topics and videos for exam chapter subtenant
 */
export const getExamtocGetTopicsAndVideosForExamChapterSubtenant = (
  params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TopicWiseVideosResponse>(
    {
      url: `/examtoc/getTopicsAndVideosForExamChapterSubtenant`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryKey = (
  params?: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
) => {
  return [
    `/examtoc/getTopicsAndVideosForExamChapterSubtenant`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
    >,
    TError = unknown,
  >(
    params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
      >
    > = ({ signal }) =>
      getExamtocGetTopicsAndVideosForExamChapterSubtenant(
        params,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
    >
  >;
export type GetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryError =
  unknown;

export function useGetExamtocGetTopicsAndVideosForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetTopicsAndVideosForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetTopicsAndVideosForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topics and videos for exam chapter subtenant
 */

export function useGetExamtocGetTopicsAndVideosForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndVideosForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getExamtocGetTopicsAndVideosForExamChapterSubtenant>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocGetTopicsAndVideosForExamChapterSubtenantQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get revise videos for exam chapter and video type
 */
export const getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId =
  (
    examId: number,
    chapterId: number,
    subtenantId: number,
    params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<ReviseVideoResponse>(
      {
        url: `/examtoc/getVideosForExamChapterSubtenantAndVideoType/${examId}/${chapterId}/${subtenantId}`,
        method: "GET",
        params,
        signal,
      },
      options,
    );
  };

export const getGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryKey =
  (
    examId?: number,
    chapterId?: number,
    subtenantId?: number,
    params?: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  ) => {
    return [
      `/examtoc/getVideosForExamChapterSubtenantAndVideoType/${examId}/${chapterId}/${subtenantId}`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
      >
    >,
    TError = unknown,
  >(
    examId: number,
    chapterId: number,
    subtenantId: number,
    params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryKey(
        examId,
        chapterId,
        subtenantId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
        >
      >
    > = ({ signal }) =>
      getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId(
        examId,
        chapterId,
        subtenantId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(examId && chapterId && subtenantId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
      >
    >
  >;
export type GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryError =
  unknown;

export function useGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  examId: number,
  chapterId: number,
  subtenantId: number,
  params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  examId: number,
  chapterId: number,
  subtenantId: number,
  params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  examId: number,
  chapterId: number,
  subtenantId: number,
  params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get revise videos for exam chapter and video type
 */

export function useGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  examId: number,
  chapterId: number,
  subtenantId: number,
  params: GetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocGetVideosForExamChapterSubtenantAndVideoTypeExamIdChapterIdSubtenantIdQueryOptions(
      examId,
      chapterId,
      subtenantId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get flashcards and questions
 */
export const getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId =
  (
    topicId: string,
    subtenantId: number,
    flashcardTypeId: number,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<FlashCardDetailsResponse>(
      {
        url: `/flashcard/flashcardsAndQuestions/${topicId}/${subtenantId}/${flashcardTypeId}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryKey =
  (topicId?: string, subtenantId?: number, flashcardTypeId?: number) => {
    return [
      `/flashcard/flashcardsAndQuestions/${topicId}/${subtenantId}/${flashcardTypeId}`,
    ] as const;
  };

export const getGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
      >
    >,
    TError = unknown,
  >(
    topicId: string,
    subtenantId: number,
    flashcardTypeId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryKey(
        topicId,
        subtenantId,
        flashcardTypeId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
        >
      >
    > = ({ signal }) =>
      getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId(
        topicId,
        subtenantId,
        flashcardTypeId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(topicId && subtenantId && flashcardTypeId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
      >
    >
  >;
export type GetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryError =
  unknown;

export function useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId<
  TData = Awaited<
    ReturnType<
      typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
    >
  >,
  TError = unknown,
>(
  topicId: string,
  subtenantId: number,
  flashcardTypeId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId<
  TData = Awaited<
    ReturnType<
      typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
    >
  >,
  TError = unknown,
>(
  topicId: string,
  subtenantId: number,
  flashcardTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId<
  TData = Awaited<
    ReturnType<
      typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
    >
  >,
  TError = unknown,
>(
  topicId: string,
  subtenantId: number,
  flashcardTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get flashcards and questions
 */

export function useGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId<
  TData = Awaited<
    ReturnType<
      typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
    >
  >,
  TError = unknown,
>(
  topicId: string,
  subtenantId: number,
  flashcardTypeId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetFlashcardFlashcardsAndQuestionsTopicIdSubtenantIdFlashcardTypeIdQueryOptions(
      topicId,
      subtenantId,
      flashcardTypeId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get memory flashcards for exam chapter subtenant
 */
export const getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant = (
  params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<MemoryFlashcardResponse>(
    {
      url: `/examtoc/getTopicsAndMemoryFlashcardsForExamChapterSubtenant`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryKey =
  (
    params?: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  ) => {
    return [
      `/examtoc/getTopicsAndMemoryFlashcardsForExamChapterSubtenant`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
      >
    >,
    TError = unknown,
  >(
    params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
        >
      >
    > = ({ signal }) =>
      getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant(
        params,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
      >
    >
  >;
export type GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryError =
  unknown;

export function useGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
    >
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
    >
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
    >
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get memory flashcards for exam chapter subtenant
 */

export function useGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant<
  TData = Awaited<
    ReturnType<
      typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
    >
  >,
  TError = unknown,
>(
  params: GetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenant
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocGetTopicsAndMemoryFlashcardsForExamChapterSubtenantQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get flashcard by flashcard IDs
 */
export const getFlashcardGetFlashcardByFlashcardIds = (
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CODResponse>(
    {
      url: `/flashcard/getFlashcardByFlashcardIds`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetFlashcardGetFlashcardByFlashcardIdsQueryKey = (
  params?: GetFlashcardGetFlashcardByFlashcardIdsParams,
) => {
  return [
    `/flashcard/getFlashcardByFlashcardIds`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetFlashcardGetFlashcardByFlashcardIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
  TError = unknown,
>(
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFlashcardGetFlashcardByFlashcardIdsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>
  > = ({ signal }) =>
    getFlashcardGetFlashcardByFlashcardIds(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFlashcardGetFlashcardByFlashcardIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>
>;
export type GetFlashcardGetFlashcardByFlashcardIdsQueryError = unknown;

export function useGetFlashcardGetFlashcardByFlashcardIds<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
  TError = unknown,
>(
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
          TError,
          Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFlashcardByFlashcardIds<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
  TError = unknown,
>(
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
          TError,
          Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFlashcardByFlashcardIds<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
  TError = unknown,
>(
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get flashcard by flashcard IDs
 */

export function useGetFlashcardGetFlashcardByFlashcardIds<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
  TError = unknown,
>(
  params: GetFlashcardGetFlashcardByFlashcardIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardByFlashcardIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFlashcardGetFlashcardByFlashcardIdsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topics by chapter exam subtenant
 */
export const getExamtocChapterTopicsGetTopicsByChapterExamSubtenant = (
  params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PracticeListResponse>(
    {
      url: `/examtoc/chapter/Topics/getTopicsByChapterExamSubtenant`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryKey =
  (params?: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams) => {
    return [
      `/examtoc/chapter/Topics/getTopicsByChapterExamSubtenant`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
    >,
    TError = unknown,
  >(
    params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
        >
      >
    > = ({ signal }) =>
      getExamtocChapterTopicsGetTopicsByChapterExamSubtenant(
        params,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
    >
  >;
export type GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryError =
  unknown;

export function useGetExamtocChapterTopicsGetTopicsByChapterExamSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocChapterTopicsGetTopicsByChapterExamSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocChapterTopicsGetTopicsByChapterExamSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topics by chapter exam subtenant
 */

export function useGetExamtocChapterTopicsGetTopicsByChapterExamSubtenant<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsGetTopicsByChapterExamSubtenantParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsGetTopicsByChapterExamSubtenant
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocChapterTopicsGetTopicsByChapterExamSubtenantQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get topic summary by chapter
 */
export const getExamtocChapterTopicsPublishedVideoAndFlashcardCount = (
  params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<TopicDetailsSummaryResponse>(
    {
      url: `/examtoc/chapter/Topics/publishedVideoAndFlashcardCount`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryKey =
  (params?: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams) => {
    return [
      `/examtoc/chapter/Topics/publishedVideoAndFlashcardCount`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
    >,
    TError = unknown,
  >(
    params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
        >
      >
    > = ({ signal }) =>
      getExamtocChapterTopicsPublishedVideoAndFlashcardCount(
        params,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
    >
  >;
export type GetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryError =
  unknown;

export function useGetExamtocChapterTopicsPublishedVideoAndFlashcardCount<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocChapterTopicsPublishedVideoAndFlashcardCount<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetExamtocChapterTopicsPublishedVideoAndFlashcardCount<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get topic summary by chapter
 */

export function useGetExamtocChapterTopicsPublishedVideoAndFlashcardCount<
  TData = Awaited<
    ReturnType<typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount>
  >,
  TError = unknown,
>(
  params: GetExamtocChapterTopicsPublishedVideoAndFlashcardCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getExamtocChapterTopicsPublishedVideoAndFlashcardCount
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetExamtocChapterTopicsPublishedVideoAndFlashcardCountQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get list of stories
 */
export const getStoryGetStoriesForExamNodeIds = (
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ListOfStoryResponse>(
    { url: `/story/getStoriesForExamNodeIds`, method: "GET", params, signal },
    options,
  );
};

export const getGetStoryGetStoriesForExamNodeIdsQueryKey = (
  params?: GetStoryGetStoriesForExamNodeIdsParams,
) => {
  return [
    `/story/getStoriesForExamNodeIds`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetStoryGetStoriesForExamNodeIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
  TError = unknown,
>(
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStoryGetStoriesForExamNodeIdsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>
  > = ({ signal }) =>
    getStoryGetStoriesForExamNodeIds(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStoryGetStoriesForExamNodeIdsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>
>;
export type GetStoryGetStoriesForExamNodeIdsQueryError = unknown;

export function useGetStoryGetStoriesForExamNodeIds<
  TData = Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
  TError = unknown,
>(
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
          TError,
          Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStoryGetStoriesForExamNodeIds<
  TData = Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
  TError = unknown,
>(
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
          TError,
          Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStoryGetStoriesForExamNodeIds<
  TData = Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
  TError = unknown,
>(
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of stories
 */

export function useGetStoryGetStoriesForExamNodeIds<
  TData = Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
  TError = unknown,
>(
  params: GetStoryGetStoriesForExamNodeIdsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoriesForExamNodeIds>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStoryGetStoriesForExamNodeIdsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get story by ID
 */
export const getStoryGetStoryId = (
  storyId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<StoryResponse>(
    { url: `/story/get/${storyId}`, method: "GET", signal },
    options,
  );
};

export const getGetStoryGetStoryIdQueryKey = (storyId?: number) => {
  return [`/story/get/${storyId}`] as const;
};

export const getGetStoryGetStoryIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getStoryGetStoryId>>,
  TError = unknown,
>(
  storyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoryId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStoryGetStoryIdQueryKey(storyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStoryGetStoryId>>
  > = ({ signal }) => getStoryGetStoryId(storyId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!storyId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStoryGetStoryId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStoryGetStoryIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStoryGetStoryId>>
>;
export type GetStoryGetStoryIdQueryError = unknown;

export function useGetStoryGetStoryId<
  TData = Awaited<ReturnType<typeof getStoryGetStoryId>>,
  TError = unknown,
>(
  storyId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoryId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGetStoryId>>,
          TError,
          Awaited<ReturnType<typeof getStoryGetStoryId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStoryGetStoryId<
  TData = Awaited<ReturnType<typeof getStoryGetStoryId>>,
  TError = unknown,
>(
  storyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoryId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStoryGetStoryId>>,
          TError,
          Awaited<ReturnType<typeof getStoryGetStoryId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStoryGetStoryId<
  TData = Awaited<ReturnType<typeof getStoryGetStoryId>>,
  TError = unknown,
>(
  storyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoryId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get story by ID
 */

export function useGetStoryGetStoryId<
  TData = Awaited<ReturnType<typeof getStoryGetStoryId>>,
  TError = unknown,
>(
  storyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStoryGetStoryId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStoryGetStoryIdQueryOptions(storyId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get documents for exam chapter subtenant
 */
export const getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId =
  (
    chapterId: number,
    subtenantId: number,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<DocumentsResponse>(
      {
        url: `/document/getDocumentsForExamChapterSubtenant/${chapterId}/${subtenantId}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryKey =
  (chapterId?: number, subtenantId?: number) => {
    return [
      `/document/getDocumentsForExamChapterSubtenant/${chapterId}/${subtenantId}`,
    ] as const;
  };

export const getGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
      >
    >,
    TError = unknown,
  >(
    chapterId: number,
    subtenantId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryKey(
        chapterId,
        subtenantId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
        >
      >
    > = ({ signal }) =>
      getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId(
        chapterId,
        subtenantId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(chapterId && subtenantId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
      >
    >
  >;
export type GetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryError =
  unknown;

export function useGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  chapterId: number,
  subtenantId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  chapterId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  chapterId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get documents for exam chapter subtenant
 */

export function useGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId<
  TData = Awaited<
    ReturnType<
      typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
    >
  >,
  TError = unknown,
>(
  chapterId: number,
  subtenantId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetDocumentGetDocumentsForExamChapterSubtenantChapterIdSubtenantIdQueryOptions(
      chapterId,
      subtenantId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get books for book-wise solution
 */
export const getBookSolutionBookSolutionForExamsExamIdSubjectId = (
  examId: number,
  subjectId: number,
  params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SubjectWiseBooksResponse>(
    {
      url: `/book_solution/book_solution_for_exams/${examId}/${subjectId}`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getGetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryKey = (
  examId?: number,
  subjectId?: number,
  params?: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
) => {
  return [
    `/book_solution/book_solution_for_exams/${examId}/${subjectId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
    >,
    TError = unknown,
  >(
    examId: number,
    subjectId: number,
    params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionBookSolutionForExamsExamIdSubjectId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryKey(
        examId,
        subjectId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
      >
    > = ({ signal }) =>
      getBookSolutionBookSolutionForExamsExamIdSubjectId(
        examId,
        subjectId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(examId && subjectId),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
    >
  >;
export type GetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryError =
  unknown;

export function useGetBookSolutionBookSolutionForExamsExamIdSubjectId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionBookSolutionForExamsExamIdSubjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBookSolutionBookSolutionForExamsExamIdSubjectId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionBookSolutionForExamsExamIdSubjectId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionBookSolutionForExamsExamIdSubjectId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBookSolutionBookSolutionForExamsExamIdSubjectId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionBookSolutionForExamsExamIdSubjectId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get books for book-wise solution
 */

export function useGetBookSolutionBookSolutionForExamsExamIdSubjectId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
  >,
  TError = unknown,
>(
  examId: number,
  subjectId: number,
  params: GetBookSolutionBookSolutionForExamsExamIdSubjectIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getBookSolutionBookSolutionForExamsExamIdSubjectId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetBookSolutionBookSolutionForExamsExamIdSubjectIdQueryOptions(
      examId,
      subjectId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get chapters for book-wise solution
 */
export const getBookSolutionChaptersForBookSolutionBookSolutionId = (
  bookSolutionId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BookWiseChapterResponse>(
    {
      url: `/book_solution/chapters_for_book_solution/${bookSolutionId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetBookSolutionChaptersForBookSolutionBookSolutionIdQueryKey = (
  bookSolutionId?: number,
) => {
  return [
    `/book_solution/chapters_for_book_solution/${bookSolutionId}`,
  ] as const;
};

export const getGetBookSolutionChaptersForBookSolutionBookSolutionIdQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
    >,
    TError = unknown,
  >(
    bookSolutionId: number,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionChaptersForBookSolutionBookSolutionId
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBookSolutionChaptersForBookSolutionBookSolutionIdQueryKey(
        bookSolutionId,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
      >
    > = ({ signal }) =>
      getBookSolutionChaptersForBookSolutionBookSolutionId(
        bookSolutionId,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!bookSolutionId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetBookSolutionChaptersForBookSolutionBookSolutionIdQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
    >
  >;
export type GetBookSolutionChaptersForBookSolutionBookSolutionIdQueryError =
  unknown;

export function useGetBookSolutionChaptersForBookSolutionBookSolutionId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
  >,
  TError = unknown,
>(
  bookSolutionId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBookSolutionChaptersForBookSolutionBookSolutionId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionChaptersForBookSolutionBookSolutionId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBookSolutionChaptersForBookSolutionBookSolutionId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionChaptersForBookSolutionBookSolutionId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
  >,
  TError = unknown,
>(
  bookSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBookSolutionChaptersForBookSolutionBookSolutionId
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBookSolutionChaptersForBookSolutionBookSolutionId
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBookSolutionChaptersForBookSolutionBookSolutionId
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionChaptersForBookSolutionBookSolutionId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
  >,
  TError = unknown,
>(
  bookSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBookSolutionChaptersForBookSolutionBookSolutionId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get chapters for book-wise solution
 */

export function useGetBookSolutionChaptersForBookSolutionBookSolutionId<
  TData = Awaited<
    ReturnType<typeof getBookSolutionChaptersForBookSolutionBookSolutionId>
  >,
  TError = unknown,
>(
  bookSolutionId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBookSolutionChaptersForBookSolutionBookSolutionId
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetBookSolutionChaptersForBookSolutionBookSolutionIdQueryOptions(
      bookSolutionId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get question IDs for exercise
 */
export const getBookSolutionQuestionIdsExerciseId = (
  exerciseId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<QuestionIdsResponse>(
    { url: `/book_solution/question_ids/${exerciseId}`, method: "GET", signal },
    options,
  );
};

export const getGetBookSolutionQuestionIdsExerciseIdQueryKey = (
  exerciseId?: number,
) => {
  return [`/book_solution/question_ids/${exerciseId}`] as const;
};

export const getGetBookSolutionQuestionIdsExerciseIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
  TError = unknown,
>(
  exerciseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBookSolutionQuestionIdsExerciseIdQueryKey(exerciseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>
  > = ({ signal }) =>
    getBookSolutionQuestionIdsExerciseId(exerciseId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!exerciseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBookSolutionQuestionIdsExerciseIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>
>;
export type GetBookSolutionQuestionIdsExerciseIdQueryError = unknown;

export function useGetBookSolutionQuestionIdsExerciseId<
  TData = Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
  TError = unknown,
>(
  exerciseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
          TError,
          Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionQuestionIdsExerciseId<
  TData = Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
  TError = unknown,
>(
  exerciseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
          TError,
          Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBookSolutionQuestionIdsExerciseId<
  TData = Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
  TError = unknown,
>(
  exerciseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get question IDs for exercise
 */

export function useGetBookSolutionQuestionIdsExerciseId<
  TData = Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
  TError = unknown,
>(
  exerciseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBookSolutionQuestionIdsExerciseId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBookSolutionQuestionIdsExerciseIdQueryOptions(
    exerciseId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get video by ID
 */
export const getVideosGetVideoVideoID = (
  videoID: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<VideoObject>(
    { url: `/videos/get_video/${videoID}`, method: "GET", signal },
    options,
  );
};

export const getGetVideosGetVideoVideoIDQueryKey = (videoID?: number) => {
  return [`/videos/get_video/${videoID}`] as const;
};

export const getGetVideosGetVideoVideoIDQueryOptions = <
  TData = Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
  TError = unknown,
>(
  videoID: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVideosGetVideoVideoIDQueryKey(videoID);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVideosGetVideoVideoID>>
  > = ({ signal }) => getVideosGetVideoVideoID(videoID, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!videoID,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVideosGetVideoVideoIDQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVideosGetVideoVideoID>>
>;
export type GetVideosGetVideoVideoIDQueryError = unknown;

export function useGetVideosGetVideoVideoID<
  TData = Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
  TError = unknown,
>(
  videoID: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
          TError,
          Awaited<ReturnType<typeof getVideosGetVideoVideoID>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideosGetVideoVideoID<
  TData = Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
  TError = unknown,
>(
  videoID: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
          TError,
          Awaited<ReturnType<typeof getVideosGetVideoVideoID>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVideosGetVideoVideoID<
  TData = Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
  TError = unknown,
>(
  videoID: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get video by ID
 */

export function useGetVideosGetVideoVideoID<
  TData = Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
  TError = unknown,
>(
  videoID: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getVideosGetVideoVideoID>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVideosGetVideoVideoIDQueryOptions(
    videoID,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get document by ID
 */
export const getDocumentGetDocumentId = (
  documentId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<DocumentObject>(
    { url: `/document/get/${documentId}`, method: "GET", signal },
    options,
  );
};

export const getGetDocumentGetDocumentIdQueryKey = (documentId?: number) => {
  return [`/document/get/${documentId}`] as const;
};

export const getGetDocumentGetDocumentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
  TError = unknown,
>(
  documentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentGetDocumentIdQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentGetDocumentId>>
  > = ({ signal }) =>
    getDocumentGetDocumentId(documentId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDocumentGetDocumentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentGetDocumentId>>
>;
export type GetDocumentGetDocumentIdQueryError = unknown;

export function useGetDocumentGetDocumentId<
  TData = Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
  TError = unknown,
>(
  documentId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentGetDocumentId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentGetDocumentId<
  TData = Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
  TError = unknown,
>(
  documentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentGetDocumentId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDocumentGetDocumentId<
  TData = Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
  TError = unknown,
>(
  documentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get document by ID
 */

export function useGetDocumentGetDocumentId<
  TData = Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
  TError = unknown,
>(
  documentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDocumentGetDocumentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDocumentGetDocumentIdQueryOptions(
    documentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get flashcard by ID
 */
export const getFlashcardGetFlashcardFlashCardId = (
  flashCardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SearchFlashcardResponse>(
    { url: `/flashcard/getFlashcard/${flashCardId}`, method: "GET", signal },
    options,
  );
};

export const getGetFlashcardGetFlashcardFlashCardIdQueryKey = (
  flashCardId?: number,
) => {
  return [`/flashcard/getFlashcard/${flashCardId}`] as const;
};

export const getGetFlashcardGetFlashcardFlashCardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
  TError = unknown,
>(
  flashCardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetFlashcardGetFlashcardFlashCardIdQueryKey(flashCardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>
  > = ({ signal }) =>
    getFlashcardGetFlashcardFlashCardId(flashCardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!flashCardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFlashcardGetFlashcardFlashCardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>
>;
export type GetFlashcardGetFlashcardFlashCardIdQueryError = unknown;

export function useGetFlashcardGetFlashcardFlashCardId<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
  TError = unknown,
>(
  flashCardId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
          TError,
          Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFlashcardFlashCardId<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
  TError = unknown,
>(
  flashCardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
          TError,
          Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFlashcardGetFlashcardFlashCardId<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
  TError = unknown,
>(
  flashCardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get flashcard by ID
 */

export function useGetFlashcardGetFlashcardFlashCardId<
  TData = Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
  TError = unknown,
>(
  flashCardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFlashcardGetFlashcardFlashCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFlashcardGetFlashcardFlashCardIdQueryOptions(
    flashCardId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get available languages
 */
export const getLanguageGetLanguages = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<LanguageObj>(
    { url: `/language/get_languages`, method: "GET", signal },
    options,
  );
};

export const getGetLanguageGetLanguagesQueryKey = () => {
  return [`/language/get_languages`] as const;
};

export const getGetLanguageGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguageGetLanguages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getLanguageGetLanguages>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetLanguageGetLanguagesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getLanguageGetLanguages>>
  > = ({ signal }) => getLanguageGetLanguages(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguageGetLanguages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLanguageGetLanguagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLanguageGetLanguages>>
>;
export type GetLanguageGetLanguagesQueryError = unknown;

export function useGetLanguageGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguageGetLanguages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLanguageGetLanguages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguageGetLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguageGetLanguages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLanguageGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguageGetLanguages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLanguageGetLanguages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguageGetLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguageGetLanguages>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLanguageGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguageGetLanguages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLanguageGetLanguages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get available languages
 */

export function useGetLanguageGetLanguages<
  TData = Awaited<ReturnType<typeof getLanguageGetLanguages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getLanguageGetLanguages>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLanguageGetLanguagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
